<!-- Nothing to show: a card that says so instead of a blank page -->
@if (loadError && !items.length) {
  <div class="empty-state mobile-empty load-error" role="alert">
    <span class="mobile-empty-icon">
      <lucide-icon name="TriangleAlert" [size]="28"></lucide-icon>
    </span>
    <p class="empty-title">{{ 'common.states.loadError' | transloco }}</p>
    <app-button
      [label]="'common.actions.retry' | transloco"
      icon="RefreshCw"
      variant="secondary"
      size="small"
      (onClick)="retry.emit()">
    </app-button>
  </div>
} @else if (!items.length) {
  <div class="empty-state mobile-empty">
    <span class="mobile-empty-icon">
      <lucide-icon name="Inbox" [size]="28"></lucide-icon>
    </span>
    <p class="empty-title">{{ 'table.empty.title' | transloco }}</p>
    <p class="empty-subtitle">{{ 'table.empty.subtitle' | transloco }}</p>
  </div>
}
<div class="accordion-list">
  @for (item of items; track item.id) {
    <div class="accordion-item" [class.expanded]="isExpanded(item.id)">
      <div class="accordion-item-header" [class.no-accordion]="hideAccordionArrow" [class.with-checkbox]="showMobileCheckboxes" (click)="hideAccordionArrow ? rowSelect.emit(item) : toggle.emit(item.id)">
        @if (showMobileCheckboxes) {
          <div class="mobile-checkbox" (click)="$event.stopPropagation()">
            <app-checkbox
              [size]="'small'"
              [(ngModel)]="item._selected"
              (ngModelChange)="checkboxChange.emit(item)">
            </app-checkbox>
          </div>
        }
        @if (shouldShowAvatar(item)) {
          <div class="item-avatar" (click)="$event.stopPropagation()">
            <app-avatar
              [userId]="hasImageField() ? undefined : getAvatarUserId(item)"
              [imageUrl]="getAvatarImage(item)"
              [name]="getMainFieldDisplayValue(item)"
              [size]="40"
              [showInfo]="false"
              [lazyLoad]="false"
              [showTooltip]="false"
            ></app-avatar>
          </div>
        }
        <div class="item-info">
          <div class="item-name">{{ getMainFieldDisplayValue(item) }}</div>
          @if (mobileSubtitleField || mobileSubtitleIcon) {
            <div class="item-subtitle">
              @if (mobileSubtitleIcon) {
                <lucide-icon [name]="mobileSubtitleIcon" [size]="16"></lucide-icon>
              }
              @if (hasMobileSubtitleValue(item)) {
                <span>{{ getMobileSubtitleValue(item) }}</span>
              } @else {
                @if (mobileSubtitleEmptyKey) {
                  <span class="no-value">{{ mobileSubtitleEmptyKey | transloco }}</span>
                } @else {
                  <span class="no-value">-</span>
                }
              }
            </div>
          }
        </div>
        @if ((showOptionsButton || getMenuActions) && menuActionsOf(item).length > 0 && !showMobileDownloadButton) {
          <div class="accordion-actions" (click)="$event.stopPropagation()">
            <div #menuButton>
              <app-button
                class="ellipsis-button-mobile"
                [icon]="'ellipsis-vertical'"
                [ariaLabel]="'common.labels.actions' | transloco"
                variant="icon-ghost"
                (onClick)="menuOpen.emit({ origin: menuButton, actions: menuActionsOf(item), item })">
              </app-button>
            </div>
          </div>
        }
        @if (showMobileDownloadButton) {
          <div class="accordion-actions" (click)="$event.stopPropagation()">
            <app-button
              class="download-button-mobile"
              [icon]="'Download'"
              [ariaLabel]="'common.a11y.download' | transloco"
              variant="icon-ghost"
              size="small"
              (onClick)="download.emit(item)">
            </app-button>
          </div>
        }
        @if (!hideAccordionArrow) {
          <button class="expand-button" [class.rotated]="isExpanded(item.id)" [attr.aria-expanded]="isExpanded(item.id)" [attr.aria-label]="(isExpanded(item.id) ? 'common.a11y.collapse' : 'common.a11y.expand') | transloco">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 9L12 15L18 9" stroke="#212529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        } @else if (showMobileNavigateArrow) {
          <button class="navigate-button" [attr.aria-label]="'common.actions.viewDetails' | transloco">
            <lucide-icon name="ChevronRight" [size]="20"></lucide-icon>
          </button>
        }
      </div>
      @if (isExpanded(item.id)) {
        <div class="accordion-item-content">
          @for (col of columns; track col.field) {
            @if (shouldShowInAccordion(col)) {
              <div class="content-row">
                <span class="label">{{ col.header }}:</span>
                <span class="value">
                  @if (col.type === 'tag') {
                    <!-- Generic tag rendering -->
                    <app-tag
                      [label]="tagOf(item, col.field)?.label!"
                      [color]="tagOf(item, col.field)?.color!"
                      size="small">
                    </app-tag>
                  } @else {
                    {{ getFormattedCellValue(item, col.field) }}
                  }
                </span>
              </div>
            }
          }
          @if (showNavigationButton) {
            <div class="content-actions">
              <app-button
                [label]="(navigationButtonLabel || 'common.actions.viewDetails') | transloco"
                variant="primary"
                size="medium"
                (onClick)="navigate.emit(item)">
              </app-button>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
<!-- Infinite scroll: reaching this loads the next page -->
@if (hasMore) {
  <div #infiniteSentinel class="infinite-sentinel">
    @if (infiniteLoading) {
      <span class="infinite-spinner"></span>
    }
  </div>
}
